import type { FaireProductEntity } from "../../entity_types/product";

export const p_4hqrtnf44y: FaireProductEntity = {
  token: "p_4hqrtnf44y",
  type: "product",
  name: "Crosa - Bohemian Rainbow Crochet Cardigan",
  brandToken: "b_qrthtbpuwu",
  brandName: "Unknown Brand",
  imageUrl:
    "https://cdn.faire.com/fastly/751beaa32b8cac21e283b0513f7c25fbaa51abc3774b560dea15ce0e439971da.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/3eb11fc6da3fa2f769d8f5d02a7f73940001ad36be55d134b1bedac26d06bd23.jpeg",
    "https://cdn.faire.com/fastly/02336a18f178821eaea877cd1bb73cad975d197fb6f114d4da312b3f4a04f3a9.jpeg",
    "https://cdn.faire.com/fastly/290790614616dd2b30d4a0fb12b6daf34ab7830a1100e6177424517870e9a5ac.jpeg",
    "https://cdn.faire.com/fastly/00ccd973b9ccfd7f03bc1bc6823a0ef629d3a9fef603952d1121c8e0a15ab211.jpeg",
    "https://cdn.faire.com/fastly/1f4793570e25d51b2ce62551ed4d4397c84d404b5b9c9b7e6bfb85af4baea2b0.jpeg",
  ],
  priceDollars: 41.57,
  description:
    "Boho-Chic Style – colorful crochet knit with fringe details for a playful, free-spirited look.\n\n Versatile Layering – Lightweight yet textured, perfect over tank tops, dresses, or swimwear for effortless summer styling.\n\n Inclusive Sizing – Available in 3 sizes (S/M/L) with a relaxed fit that drapes beautifully on most body types.\n\n This vibrant cover-up adds instant festival flair to any outfit—ideal for beach days, music festivals, or casual brunches.\n\nOur popular brand offers UPC-coded, retail-ready products, ensuring quality and shopping ease. Each item is crafted for excellence and ready for immediate retail. For inquiries, our responsive customer service is at your service, guaranteeing a seamless and supportive customer experience.\n",
  tags: [],
  msrpDollars: 83.14,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:27:25.995Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
